// this file will be used to show loader

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class LoaderService {
  private pendingCount = 0;
  isLoading = new BehaviorSubject<boolean>(false);
  show(): void {
    this.pendingCount += 1;
    if (this.pendingCount === 1) {
      this.isLoading.next(true);
    }
  }
  hide(): void {
    if (this.pendingCount > 0) {
      this.pendingCount -= 1;
    }
    if (this.pendingCount === 0) {
      this.isLoading.next(false);
    }
  }
}
